export const infraConfig = {
    apiEndpoint : "https://minsidafalcks-be-staging.azurewebsites.net/api1",
    usePort: false,
    clientId: 'f2c03726-0a96-4822-adc3-da0f408d35f0', 
    identityServerEndpoint : "https://login.microsoftonline.com/falcksomnibus.onmicrosoft.com/v2.0",
    documentsUrl: "https://minsidafalcks-docs.azurewebsites.net"
};

